var _circle, _g, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDriverIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 53,
    viewBox: "0 0 50 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 21.2745,
    cy: 13.024,
    r: 10.7349,
    fill: "#6B8F74"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_216_100)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.4297 26.2848C29.1363 26.2848 23.1689 32.2521 23.1689 39.5456C23.1689 46.839 29.1363 52.8064 36.4297 52.8064C43.7232 52.8064 49.6905 46.839 49.6905 39.5456C49.6905 32.2521 43.7232 26.2848 36.4297 26.2848ZM36.4297 28.9369C40.5406 28.9369 44.2536 31.3239 45.9775 34.9043L39.6123 37.1586C38.8167 36.0978 37.6232 35.5673 36.4297 35.5673C35.2363 35.5673 34.0428 36.0978 33.3797 37.026L26.882 34.9043C28.6059 31.3239 32.3189 28.9369 36.4297 28.9369ZM35.1036 50.0216C29.9319 49.3585 25.8211 44.8499 25.8211 39.5456C25.8211 38.7499 25.9537 38.0869 26.0863 37.2912L32.4515 39.5456C32.4515 41.2695 33.5124 42.7282 35.1036 43.2586V50.0216ZM36.4297 40.8716C35.6341 40.8716 35.1036 40.3412 35.1036 39.5456C35.1036 38.7499 35.6341 38.2195 36.4297 38.2195C37.2254 38.2195 37.7558 38.7499 37.7558 39.5456C37.7558 40.3412 37.2254 40.8716 36.4297 40.8716ZM37.7558 50.0216V43.2586C39.3471 42.7282 40.408 41.2695 40.408 39.5456L46.7731 37.2912C46.9057 38.0869 47.0384 38.7499 47.0384 39.5456C47.0384 44.9825 42.9275 49.3585 37.7558 50.0216Z",
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.65771 45.8602C1.65771 37.307 10.1667 30.3893 20.6427 30.3893M20.6427 23.7589C23.5735 23.7589 26.3843 22.5946 28.4567 20.5222C30.5291 18.4498 31.6934 15.6391 31.6934 12.7082C31.6934 9.77743 30.5291 6.96665 28.4567 4.89425C26.3843 2.82185 23.5735 1.65759 20.6427 1.65759C17.7119 1.65759 14.9011 2.82185 12.8287 4.89425C10.7563 6.96665 9.59208 9.77743 9.59208 12.7082C9.59208 15.6391 10.7563 18.4498 12.8287 20.5222C14.9011 22.5946 17.7119 23.7589 20.6427 23.7589Z",
    stroke: "white",
    strokeWidth: 3.3152,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_216_100"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26.5216,
    height: 26.5216,
    fill: "white",
    transform: "translate(23.1689 26.2848)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDriverIcon);
export default __webpack_public_path__ + "static/media/driverIcon.0c277bd535e0aaa0ca1b41ffd0ee56f3.svg";
export { ForwardRef as ReactComponent };